import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPostTag } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import parseError from "../../../utils/parseError";

export const useCreatePostTag = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutate: createTagMutate, isPending: isCreating } = useMutation({
        mutationFn: createPostTag,
        onSuccess: (res) => {
            toast.success(res.message || "Post tag created successfully");
            queryClient.invalidateQueries(["post-tags"]);
            navigate("/blog/tags");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create tags");
        },
    });

    return { createTagMutate, isCreating };
};